import React from 'react'
import Modal from '../../../../../common/modal/Modal'
import Icons from '../../../../../common/icons/Icons'
import UserInfo from './UserInfo.tsx'
import { modalManageUserId } from '../Utils'

const ModalManageUser = () => {

  return (
    <>
      <Modal
        modalId={ modalManageUserId }
        modalHeading={'Manage Member'}
        buttonTitle={''}
      >
        <main className="msync-modal__body">
          <UserInfo modalId={ modalManageUserId } />
        </main>
      </Modal>
    </>
  )
}

export default ModalManageUser
